import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from "react-redux";
import {
    ProfieldModel,
} from "./index";
import { config, ROLES, DISPATCH_ID } from '../libs/utils/Const';
import { Modal } from './index';
import $ from "jquery";
import './navBar.css';
import { ApiClient } from "../libs/apiClient/ApiClient";
import moment from 'moment';
import ReactDOM from 'react-dom';

let modal = new Modal();
let apiClient = ApiClient.getInstance();

class MenuProfile extends Component {
    constructor(props) {
        super(props);
        
        this.state = {
            marcas: [],
            aparatos: [],
            refacciones: [],
            fabricantes: [],
            materiales: [],
            seller: JSON.parse(localStorage.getItem(config.general.localStorageNamed + 'PartnerUser')),
            vendor: JSON.parse(localStorage.getItem(config.general.localStorageNamed + 'vendor')),
            user: JSON.parse(localStorage.getItem(config.general.localStorageNamed + 'CurrentUser')),
        };
      }

      openOrder = async () => {
        const {enableSpinner, notificationReducer: {showAlert} } = this.props;
        const { user } = this.state
        enableSpinner(true);
        
        if (user !== null) { 
            $('#dataProfiel').modal('show');   
        }else{
            showAlert({type: 'warning', message: "No hay un cliente seleccionado"})
        }
             
        enableSpinner(false);
        return;
    };

    logOut = async () => {
        const { configReducer, setItemsAutoComplete, setBusiness, setToken, setUser, setRememberUser, setRole, shoppingCartReducer: { getShoppingCart }, sessionReducer: { user } } = this.props;
        const { seller, vendor } = this.state;
        ////console.log('logout');
        // ---------------------------------------------------------------------------------------------
        let today = moment().format('YYYY-MM-DD');
        let time = moment().format('h:mm:ss a');
        let data = [];
        // Funcion AutoComplete al cerrar sesión
        let suggestions = [];
        let apiResponse = await apiClient.AutoComplete();
        

        if(seller && seller.U_FMB_Handel_Perfil == 2 ){
            data = {
                CardCode : seller.salesPrson,
                CardName : seller.lastName + ' ' + seller.firstName,
                Date : today, 
                Time : time,
                TypeUser : 'Vendedor',
                Email : seller.email,
                IP : '192.168.0.139', 
                Business : 'Irco',
                Session : 0
            }
        }else if(seller.U_FMB_Handel_Perfil == 0){
            data = {
                CardCode : user.CardCode,
                CardName : user.CardName,
                Date : today, 
                Time : time,
                TypeUser : 'Cliente',
                Email : user.U_FMB_Handel_Email,
                Business : 'Irco',
                Session : 0
            }
        }
        if( Object.keys(data).length > 0){
            await apiClient.sendData(data);
        }
         // ---------------------------------------------------------------------------------------------
         localStorage.removeItem(config.general.localStorageNamed + 'Role');
         localStorage.removeItem(config.general.localStorageNamed + 'Token');
         localStorage.removeItem(config.general.localStorageNamed + 'CurrentUser');
         localStorage.removeItem(config.general.localStorageNamed + 'PartnerUser');
         localStorage.removeItem(config.general.localStorageNamed + 'RememberUser');
         localStorage.removeItem(config.general.localStorageNamed + 'vendor');
         localStorage.clear();
         configReducer.history.goHome();
 
         setRole(ROLES.PUBLIC);
         setBusiness(config.general.business);
         setToken(undefined);
         setUser({});
         setRememberUser(false);
 
         // COnsulta de AutoComplete al cerrar sesión
         suggestions = apiResponse.data.data;
         setItemsAutoComplete(suggestions);
 
         setTimeout(async () => {
             await getShoppingCart(true);
         }, 300);
 
     };

    render() {
        const { configReducer, sessionReducer: { user, role }, sessionReducer } = this.props;
        const { order, seller } = this.state;
        
        return (
            <div>                
                <div className="">
                    {/* <li className="nav-item" onClick={() => { configReducer.history.goProfile(); }}>
                        <a className="nav-link dropdown-menu-item" style={{ color: config.navBar.textColor }}>
                            <strong><span style={{color: config.navBar.textColor2}}>{user.CardName}</span></strong>
                        </a>
                    </li> */}
                
                    <li className="nav-item mt-5" onClick={() => { configReducer.history.goProfile(); }}>
                        <a className="nav-link dropdown-menu-item" style={{ color: config.navBar.textColor }}>
                            <span  className="dropdown-item dropdown-menu-item" style={{color: config.navBar.textColor2}}>Mi Perfil</span>
                        </a>
                    </li>
                    { role != 'PUBLIC' &&
                        <li className="nav-item"onClick={() => this.openOrder()}>
                            <a className="nav-link dropdown-menu-item" style={{ color: config.navBar.textColor }}>
                                <span  className="dropdown-item dropdown-menu-item" style={{color: config.navBar.textColor2}}>Información</span>
                            </a>
                        </li>
                    }
                    {seller ? seller.U_FMB_Handel_Perfil != '0' && seller.U_FMB_Handel_Perfil != 5 ? 
                        <li className="nav-item" onClick={() => { configReducer.history.goSelectClient(); }}>
                            <a className="nav-link dropdown-menu-item" style={{ color: config.navBar.textColor }}>
                                <span className="dropdown-item dropdown-menu-item" style={{color: config.navBar.textColor2}}>Mis clientes</span>
                            </a>
                        </li>
                        : "" : ""
                    }

                    {seller ? seller.U_FMB_Handel_Perfil != '0' && seller.U_FMB_Handel_Perfil != 5 && seller.U_FMB_Bonificaciones === "1" ?
                        <li className="nav-item" onClick={() => { configReducer.history.goPromocionales(); }}>
                            <a className="nav-link dropdown-menu-item" style={{ color: config.navBar.textColor }}>
                                <span className="dropdown-item dropdown-menu-item" style={{color: config.navBar.textColor2}}>Bonificaciones</span>
                            </a>
                        </li>
                        : "" : ""
                    }

                    {config.modules.subirArchivoExcel && seller ? seller.U_FMB_Handel_Perfil != 5 && Object.entries(user).length !== 0 ?
                        <li className="nav-item" onClick={() => { configReducer.history.goSubirArchivo(); }}>
                            <a className="nav-link dropdown-menu-item" style={{ color: config.navBar.textColor }}>
                                <span className="dropdown-item dropdown-menu-item" style={{color: config.navBar.textColor2}}>Subir archivo OC</span>
                            </a>
                        </li>
                        : "" : ""
                    }

                    {seller ? seller.U_FMB_Handel_Perfil != 5 && Object.entries(user).length !== 0 ?
                        <li className="nav-item" onClick={() => { configReducer.history.goReports(); }}>
                            <a className="nav-link dropdown-menu-item" style={{ color: config.navBar.textColor }}>
                                <span className="dropdown-item dropdown-menu-item" style={{color: config.navBar.textColor2}}>Mis reportes</span>
                            </a>
                        </li>
                        : "" : ""
                    }
                    {user.wishlist === 1 &&
                        <li className="nav-item" onClick={() => { configReducer.history.goBackOrder(); }}>
                            <a className="nav-link dropdown-menu-item" style={{ color: config.navBar.textColor }}>
                                <span className="dropdown-item dropdown-menu-item" style={{color: config.navBar.textColor2}}>Lista de deseos</span>
                            </a>
                        </li>
                    }
                    {/* {user.banners === "on" && */}
                    {user ? user.U_FMB_Handel_Admin == 1 ?
                        <li className="nav-item">
                            <a className="nav-link dropdown-menu-item" style={{ color: config.navBar.textColor2 }}>
                                <span>
                                    <Link to='/adminBanners' className="dropdown-item dropdown-menu-item" style={{color: config.navBar.textColor2}} >Adm. Banners 3</Link>
                                </span>
                            </a>
                        </li>
                        : "" : ""
                    }
                    {/* seller ? seller.U_FMB_AdmBlogNoticia == 1 ? */}
                    {seller ? seller.U_FMB_AdmBlogNoticia == 1 ?
                        <li className="nav-item">
                            <a className="nav-link dropdown-menu-item" style={{ color: config.navBar.textColor2 }}>
                                <span>
                                    <Link to='/admiNewsBlog' className="dropdown-item dropdown-menu-item" style={{color: config.navBar.textColor2}} >Adm. Blog de noticias</Link>
                                </span>
                            </a>
                        </li>
                        : "" : ""
                    }

                    {seller ? seller.U_FMB_Handel_Perfil === 5
                            ? 
                        <li className="nav-item" onClick={() => { configReducer.history.goAutorizaciones(); }}>
                            <a className="nav-link dropdown-menu-item" style={{ color: config.navBar.textColor2 }}>
                                <span  style={{color: config.navBar.textColor2}}>Autorizaciones</span>
                            </a>
                        </li>
                            : "" : ""
                        }
                    <li className="nav-item" onClick={() => { this.logOut(); }}>
                        <a className="nav-link dropdown-menu-item" style={{ color: config.navBar.textColor }}>
                            <span className="dropdown-item dropdown-menu-item" style={{color: config.navBar.textColor2}}>Cerrar Sesión</span>
                        </a>
                    </li>
                    
                </div>
                <ProfieldModel order={order} />
            </div>
        );
    }
}

const mapStateToProps = store => {
    return {
        itemsReducer: store.ItemsReducer,
        sessionReducer: store.SessionReducer,
        configReducer: store.ConfigReducer,
        shoppingCartReducer: store.ShoppingCartReducer,
        notificationReducer: store.NotificationReducer
    };
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({ type: DISPATCH_ID.CONFIG_SET_SPINNER, value }),
        setItemsSearch: value => dispatch({ type: DISPATCH_ID.ITEMS_SET_ITEMS, value }),
        setItemsFilterSearch: value => dispatch({ type: DISPATCH_ID.ITEMS_SAVE_ITEMS_FILTER, value }),

        setRole: value => dispatch({ type: DISPATCH_ID.SESSION_SET_ROLE, value }),
        addNotificationReference: value => dispatch({ type: DISPATCH_ID.NOTIFICATION_SET_ALERT_REFERENCE, value }),
        setBusiness: value => dispatch({ type: DISPATCH_ID.SESSION_SET_BUSINESS_ID, value }),
        setToken: value => dispatch({ type: DISPATCH_ID.SESSION_SET_TOKEN, value }),
        setUser: value => dispatch({ type: DISPATCH_ID.SESSION_SET_USER, value }),
        setRememberUser: value => dispatch({ type: DISPATCH_ID.SESSION_SET_REMEMBER_USER, value }),
        setLogOutReference: value => dispatch({ type: DISPATCH_ID.CONFIG_SET_LOG_OUT_REFERENCE, value }),
        setIdCategory: value => dispatch({type: DISPATCH_ID.ITEMS_SET_IDCATEGORY, value}),
        setNextPage:  value => dispatch({type: DISPATCH_ID.ITEMS_SET_NEXTPAGE, value}),
        setLocation:  value => dispatch({type: DISPATCH_ID.ITEMS_SET_LOCATION, value}),
        setItemsAutoComplete: value => dispatch({type: DISPATCH_ID.ITEMS_SET_AUTO_COMPLETE, value}),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MenuProfile);
